import { render, staticRenderFns } from "./ManuallyRequest.vue?vue&type=template&id=16362d95&"
import script from "./ManuallyRequest.vue?vue&type=script&lang=js&"
export * from "./ManuallyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports